<div class="wrapper">
  <app-home-card-header [type]="type" [name]="'New!'"></app-home-card-header>
  <div class="body">
    <svg-icon svgClass="icon" name="icon-card-new"></svg-icon>
  </div>
</div>
